module.exports = __webpack_public_path__ + "img/logo-lg-dark.4a08611a.svg";